import { NgModule } from '@angular/core';
import { KuiProgressComponent } from './progress.component';

@NgModule({
  exports: [KuiProgressComponent],
  declarations: [KuiProgressComponent],
})
export class KuiProgressModule { }
